import { render, staticRenderFns } from "./MenuAvator.vue?vue&type=template&id=ae63e9ba&scoped=true&"
import script from "./MenuAvator.vue?vue&type=script&lang=js&"
export * from "./MenuAvator.vue?vue&type=script&lang=js&"
import style0 from "./MenuAvator.vue?vue&type=style&index=0&id=ae63e9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae63e9ba",
  null
  
)

export default component.exports